import type { CaseFileRecord } from "@/components/MedicalChronology/Files/types";

import { supabase } from "./supabaseClient";

export class CaseFileService {
  async getCaseFiles(caseId: string): Promise<CaseFileRecord[]> {
    const { data, error } = await supabase
      .from("case_files")
      .select(
        `
        file_id,
        bucket_url,
        filename,
        page_count,
        processing_status,
        created_at,
        case_file_categories (
          category_name
        )
      `
      )
      .eq("case_id", caseId)
      .or("is_deleted.is.null,is_deleted.eq.false")
      .order("created_at", { ascending: false });

    if (error) throw error;
    return (data ?? []) as CaseFileRecord[];
  }
}
